import ApiClient from './ApiClient';

class GoogleBusinessProfileAPI extends ApiClient {
  constructor() {
    super('google_business_profile', { accountScoped: true });
  }

  // GET connection status
  getConnection() {
    return axios.get(`${this.url}/connection`);
  }

  // POST to get the OAuth authorization URL
  initiateConnect() {
    return axios.post(`${this.url}/connection/connect`);
  }

  // GET available GBP locations
  getLocations() {
    return axios.get(`${this.url}/connection/locations`);
  }

  // PATCH to set the selected GBP location
  setLocation(payload) {
    return axios.patch(`${this.url}/sync/location`, payload);
  }

  // POST to trigger review synchronization
  syncReviews() {
    return axios.post(`${this.url}/sync`);
  }

  // DELETE to disconnect
  disconnect() {
    return axios.delete(`${this.url}/connection`);
  }
}

export default new GoogleBusinessProfileAPI();
